import { AxiosResponse } from 'axios';
import {
  IReEnrollmentCyclesResponse,
  IReEnrollmentCycleResponseById,
  IReEnrollmentCyclesQueryParams,
  IActivateReEnrollmentCycleResponse,
  IFinalizeReEnrollmentCycleResponse,
} from '../../interface/reEnrollment.interface';
import api from '../api';

const fetchReEnrollmentCycles = async (
  params?: IReEnrollmentCyclesQueryParams,
): Promise<AxiosResponse<IReEnrollmentCyclesResponse>> => {
  const res: AxiosResponse<IReEnrollmentCyclesResponse> = await api.get('/re-enrollment/cycles', {
    params,
  });
  return res;
};

const fetchReEnrollmentCycle = async (
  cycleId: string,
): Promise<AxiosResponse<IReEnrollmentCycleResponseById>> => {
  const res: AxiosResponse<IReEnrollmentCycleResponseById> = await api.get(
    `/re-enrollment/cycles/${cycleId}`,
  );
  return res;
};

const activateReEnrollmentCycle = async (
  cycleId: string,
): Promise<AxiosResponse<IActivateReEnrollmentCycleResponse>> => {
  const res: AxiosResponse<IActivateReEnrollmentCycleResponse> = await api.patch(
    `/re-enrollment/cycles/${cycleId}/activate`,
  );
  return res;
};

export const finalizeReEnrollmentCycle = async (
  cycleId: string,
): Promise<AxiosResponse<IFinalizeReEnrollmentCycleResponse>> => {
  const res: AxiosResponse<IFinalizeReEnrollmentCycleResponse> = await api.patch(
    `/re-enrollment/cycles/${cycleId}/finalize`,
  );
  return res;
};

export const reEnrollmentService = {
  fetchReEnrollmentCycles,
  fetchReEnrollmentCycle,
  activateReEnrollmentCycle,
  finalizeReEnrollmentCycle,
};
